<template>


    <div class="container container-tabs">

        <div class="handle-box-search">

            <el-row class="head-search">

                <el-col :span="8">

                    <span class="title">司机姓名:</span>
                    <el-input v-model="search_data.recruit_driver_name" placeholder="请输入司机名称" class="handle-input mr10"
                              @keyup.enter.native="searchRecruitLists"></el-input>

                </el-col>


                <el-col :span="8">

                    <span class="title">司机电话:</span>
                    <el-input v-model="search_data.recruit_phone" placeholder="请输入司机电话" class="handle-input mr10" maxlength="11"
                              @keyup.enter.native="searchRecruitLists"></el-input>

                </el-col>

                <el-col :span="24">
                    <el-col :span="8" style="margin-top: 10px">

                        <span class="title">全职兼职:</span>
                        <el-select v-model="search_data.recruit_full_part" placeholder="请选择推广标题" style="width: 150px; margin-right: 20px;"
                                   @keyup.enter.native="searchRecruitLists"  clearable>
                            <el-option label="全职" value="1"></el-option>
                            <el-option label="兼职" value="0"></el-option>
                        </el-select>

                    </el-col>



                </el-col>



            </el-row>





            <div>

                <el-button type="primary" icon="el-icon-search" @click="searchRecruitLists">搜索</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

            </div>

        </div>


        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">




                    <el-dropdown
                            split-button
                            type="primary"
                            @click="edit_isShow = !edit_isShow; editData = scope.row.id "
                            trigger="click"
                    >

                        修改备注

                        <el-dropdown-menu slot="dropdown">

                            <el-dropdown-item @click.native="del(scope.row.id)">
                                删除
                            </el-dropdown-item>

                        </el-dropdown-menu>

                    </el-dropdown>




                </template>
            </el-table-column>

            <el-table-column prop="status" label="状态" min-width="150">
                <template slot-scope="scope">

                    <el-tag :type="scope.row.status=='0'?'info':scope.row.status=='1'?'success':'warning'">
                        {{ scope.row.status=='0'?'未回访':scope.row.status=='1'?'已回访':'已入职' }}
                    </el-tag>


                </template>
            </el-table-column>



            <el-table-column prop="recruit_driver_name" label="司机名称" min-width="150">
            </el-table-column>
            <el-table-column prop="recruit_phone" label="司机电话" min-width="150">
            </el-table-column>
            <el-table-column prop="recruit_sex.alias" label="性别" min-width="150">
            </el-table-column>

            <el-table-column prop="recruit_in_age.alias" label="年龄" min-width="150">
            </el-table-column>

            <el-table-column prop="recruit_full_part.alias" label="类型" min-width="150">
            </el-table-column>

            <el-table-column prop="recruit_source" label="来源" min-width="150">
                <template slot-scope="scope">

                    <p>{{ scope.row.recruit_source=='anbo'?'安泊洗车':'' }}</p>


                </template>
            </el-table-column>

            <el-table-column prop="recruit_car_age" label="驾龄" min-width="150">
                <template slot-scope="scope">

                        <p>{{ scope.row.recruit_car_age.alias }}</p>


                </template>
            </el-table-column>

            <el-table-column prop="recruit_car_type" label="驾驶证类型" min-width="150">
            </el-table-column>

            <el-table-column prop="recruit_clear.alias" label="政治背景" min-width="150">
            </el-table-column>

            <el-table-column prop="recruit_deduct_point.alias" label="最近三个记分周期有无扣满12分记录" min-width="150">
            </el-table-column>

            <el-table-column prop="time.YmdHis" label="申请时间" min-width="150">
            </el-table-column>
            <el-table-column prop="id_card_portrait.url" label="身份证人像面" min-width="130">
                <template slot-scope="scope">
                    <el-image style="width: 80px; height: 80px;border: 1px solid #eee;border-radius: 5px;"
                        :src="scope.row.id_card_portrait.url" v-if="scope.row.id_card_portrait.url!=''" :preview-src-list="srcList">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column prop="id_card_china.url" label="身份证国徽面" min-width="130">
                <template slot-scope="scope">
                    <el-image style="width: 80px; height: 80px;border: 1px solid #eee;border-radius: 5px;"
                        :src="scope.row.id_card_china.url" v-if="scope.row.id_card_china.url!=''" :preview-src-list="srcList">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column prop="driver_card.url" label="驾驶证图片" min-width="130">
                <template slot-scope="scope">
                    <el-image style="width: 80px; height: 80px;border: 1px solid #eee;border-radius: 5px;"
                        :src="scope.row.driver_card.url" v-if="scope.row.driver_card.url!=''" :preview-src-list="srcList">
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column prop="driver_card_and.url" label="驾驶证附页图片" min-width="130">
                <template slot-scope="scope">
                    <el-image style="width: 80px; height: 80px;border: 1px solid #eee;border-radius: 5px;"
                        :src="scope.row.driver_card_and.url" v-if="scope.row.driver_card_and.url!=''" :preview-src-list="srcList">
                    </el-image>
                </template>
            </el-table-column>









        </el-table>


        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>



        <!-- 审核组件 -->
        <editdriverRecruit :isShow="edit_isShow" :data="editData" @onSubmit="recruitLists">
        </editdriverRecruit>


    </div>


</template>

<script>
    import axios from 'axios';
    import { config } from '../../../utils/config';

    var _this;
    import editdriverRecruit from './editdriverRecruit.vue';


    export default {
        components: {

            editdriverRecruit

        },
        data() {
            return {

                srcLists:[],

                edit_isShow:false,

                // 传入子组件的数据
                editData: '',

                city_data:[],



                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    recruit_driver_name: '',
                    recruit_phone:'',
                    recruit_full_part:''
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                },
            };
        },
        created() {
            _this = this;
            _this.recruitLists();
        },

        methods: {
            del(code){

                this.$confirm('此操作将永久删除该此条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.$post(
                        "/recruit/delRecruit",
                        {
                            id:code
                        }
                    )
                        .then(res => {

                            _this.$message.success(res.msg)
                            _this.recruitLists()

                        }).catch((err) => {

                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });


            },
            // getCityList(){
            //
            //     _this.$nextTick(function() {
            //         axios.defaults.baseURL = config.axios_normalURL; //请求base url
            //
            //         _this.$post('/city/getCityLists')
            //             .then((res) => {
            //
            //                 _this.city_data = res.data;
            //
            //                 axios.defaults.baseURL = config.axios_baseURL; //请求base url
            //             })
            //             .catch((err) => {
            //             });
            //         axios.defaults.baseURL = config.axios_baseURL; //请求base url
            //     });
            //
            //
            // },

            searchRecruitLists(){
                _this.search_data.page = 1;
                _this.recruitLists();
            },



            // 搜索司机列表
            recruitLists() {
                _this.$post(
                    "/recruit/recruitLists",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {

                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;
                        _this.srcLists.length = 0;
                        for(let i=0;i<res.data.length;i++){
                            _this.srcLists.push(res.data[i].id_card_portrait.url)
                            _this.srcLists.push(res.data[i].id_card_china.url)
                            _this.srcLists.push(res.data[i].driver_card.url)
                            _this.srcLists.push(res.data[i].driver_card_and.url)
                        }


                    }).catch((err) => {

                })
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.recruitLists();

            },

            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        max-width: 150px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-dropdown {
        vertical-align: top;
    }

    .el-dropdown+.el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>
